import {
  ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild
} from '@angular/core';

export const DEFAULT_TEXT = 'Submit';
export const DEFAULT_INTERVAL = 1.5;
export const DEFAULT_ITERATIONS = 10;

@Component({
  selector: 'progress-button',
  template: `<button (click)="submit()">
  <label class="progress_name">{{ state }}</label>
  <label class="progress_spinner" *ngIf="spinner">
    <div [class.hidden]="!running" class="spinner"></div>
  </label>
  <label #progressBar
        *ngIf="progress"
         class="progress_loading"
         [style.transition]="getTransition()"
         [class.loading]="running"
         [class.finish]="!running"></label>
</button>
`,
  styles: [`button{position:relative;width:100%;height:100%;background:0 0;color:currentColor;border:0;margin:0;font-size:inherit;cursor:pointer}button:hover{color:currentColor}button:focus{outline:0}button .progress_name{z-index:2}button .progress_spinner{position:absolute;top:7px;right:7px;z-index:2}button .progress_spinner .spinner{border:4px solid rgba(255,255,255,.2);border-top:4px solid rgba(255,255,255,.6);border-radius:50%;width:19px;height:19px;-webkit-animation:2s linear infinite spin;animation:2s linear infinite spin;margin:0!important}@-webkit-keyframes spin{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spin{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}button .progress_spinner .hidden{display:none}button .progress_loading{position:absolute;top:-1px;left:-1px;width:0;height:calc(100% + 2px);background:rgba(255,255,255,.2)}button .progress_loading.loading{width:100%}button .progress_loading.finish{width:0}`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressButtonComponent implements OnInit, OnChanges {

  @ViewChild('progressBar') progressBar;

  @Input('text') text: string;
  @Input('loading') loading: string;
  @Input('timeout') timeout: number;
  @Input('isRunning') isRunning: boolean;

  @Input('spinner') spinner: boolean = true;
  @Input('progress') progress: boolean = true;
  @Output('start') start: EventEmitter<boolean> = new EventEmitter<boolean>();

  public state: string;
  public running: boolean;

  private _text: string;
  private _loading: string;
  private _timer: any;
  private _currentTimer: number = 1;
  private _currentIteration: number = 0;

  constructor() {}

  ngOnInit() {
    this._text = ( this.text ) ? this.text : DEFAULT_TEXT;
    this._loading = ( this.loading ) ? this.loading : this._text;
    this.state = this._text;
    this.running = this.isRunning;
  }

  ngOnChanges() {
    if(this.running && !this.isRunning && this._timer) {
      clearTimeout( this._timer) ;
      this.progressBar.nativeElement.style.transition = 'width 1s ease-out';
      this.progressBar.nativeElement.style.width = '100%';
      setTimeout(() => {
        this.progressBar.nativeElement.style.transition = 'width 0s ease-out';
        this.progressBar.nativeElement.style.width = '0%';
        this.running = this.isRunning;
        this.state = this._text;
      },  1100)
    } else {
      this.running = this.isRunning;
      this.state = ( this.running ) ? this._loading : this._text;
    }
  }

  public getTransition() {
    if (this.timeout && this.progress) {
      return ( this.running ) ? 'width ' + this.timeout + 'ms ease-out' : 'width 0s';
    }
  }


  public submit() {
    if (!this.running && this.timeout) {
      this.state = this._loading;
      this.start.emit(true);
      setTimeout(() => {
        this.start.emit(false);
      }, this.timeout);
    } else if(!this.running) {
      this.state = this._loading;
      this.start.emit(true);
      if (this.progress) {
        let sequence = () => {
          this._currentTimer = this._currentTimer * DEFAULT_INTERVAL;
          this._currentIteration++;
          this.progressBar.nativeElement.style.transition = 'width ' + this._currentTimer + 's ease-out';
          this.progressBar.nativeElement.style.width = ( this._currentIteration * DEFAULT_ITERATIONS ) + '%';
          this._timer = setTimeout(sequence, this._currentTimer * 1000);
        };
        sequence();
      }
    }
  }
}
